// Request correlation id generation for API calls (X-Request-Id).

const M64 = (1n << 64n) - 1n;
const SESSION_SALT = 0x6c1fd93a84b7250en;

// UUID bit positions available for id material (version/variant positions are fixed by RFC 4122).
const FREE_BITS: bigint[] = [];
for (let i = 127; i >= 0; i--) {
    if (i === 79 || i === 78 || i === 77 || i === 76 || i === 63 || i === 62) continue;
    FREE_BITS.push(BigInt(i));
}

function mix(key: bigint, seq: bigint): bigint {
    let x = (key ^ ((seq + 0x9e3779b97f4a7c15n) & M64)) & M64;
    x = ((x ^ (x >> 30n)) * 0xbf58476d1ce4e5b9n) & M64;
    x = ((x ^ (x >> 27n)) * 0x94d049bb133111ebn) & M64;
    return (x ^ (x >> 31n)) & M64;
}

function randomBits(count: number): bigint {
    let value = 0n;
    if (typeof crypto !== 'undefined' && crypto?.getRandomValues) {
        const bytes = crypto.getRandomValues(new Uint8Array(Math.ceil(count / 8)));
        for (const b of bytes) value = (value << 8n) | BigInt(b);
    } else {
        for (let remaining = count; remaining > 0; remaining -= 16) {
            value = (value << 16n) | BigInt(Math.floor(Math.random() * 0x10000));
        }
    }
    return value & ((1n << BigInt(count)) - 1n);
}

function fold(payload: string): bigint {
    let h = 0xcbf29ce484222325n;
    for (const b of new TextEncoder().encode(payload)) {
        h = ((h ^ BigInt(b)) * 0x100000001b3n) & M64;
    }
    return h;
}

function format(payload: bigint): string {
    let u = (0x4n << 76n) | (0b10n << 62n);
    for (let k = 0; k < 122; k++) {
        u |= ((payload >> BigInt(121 - k)) & 1n) << FREE_BITS[k];
    }
    const hex = u.toString(16).padStart(32, '0');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function buildRequestId(payload?: string): string {
    const seq = randomBits(58);
    const low = payload === undefined ? randomBits(64) : fold(payload) ^ mix(SESSION_SALT, seq);
    return format((seq << 64n) | low);
}
